import FooterMobile from '../../components/Footer/mobile/FooterMobile';
import HeaderMobile from '../../components/Header/mobile/HeaderMobile';
import useIsDevice from '../../hooks/useIsDevice';
import ServicesMobile from './mobile/ServicesMobile';

const Services = () => {
  const { isMobile } = useIsDevice();
  // const { pathname } = useLocation();
  return (
    <>
      {isMobile ? <HeaderMobile /> : null}
      {isMobile ? <ServicesMobile /> : null}
      {isMobile ? <FooterMobile /> : null}
    </>
  );
};

export default Services;
